import React, { useCallback, useContext } from "react";
import TwinInput, { fields } from "./TwinInput";
import LogicContainer from "./LogicContainer";
import BusinessLogicContext, {
	BusinessLogicContextProps,
} from "contexts/BusinessLogicContext";
import { useTranslation } from "react-i18next";
import LogicCheck from "./LogicCheck";

export default () => {
	const { t } = useTranslation();
	const { value } = useContext(
		BusinessLogicContext
	) as BusinessLogicContextProps;

	// Reformat dataMap values so they are correct when passed into the store
	const reformatDataMapValues = useCallback((vals: fields[]) => {
		return vals.map((item: fields) => {
			const array: string[] = [];
			const fieldOneTrim = item.fieldOne
				? item.fieldOne.trim()
				: undefined;
			const fieldTwoTrim = item.fieldTwo
				? item.fieldTwo.trim()
				: undefined;
			if (fieldOneTrim && fieldOneTrim !== "")
				array[0] = `/${fieldOneTrim.replace("/", "")}`;
			if (fieldTwoTrim && fieldTwoTrim !== "")
				array[1] = `/${fieldTwoTrim.replace("/", "")}`;
			return array;
		});
	}, []);

	return (
		<div className="business-logic-content">
			<LogicContainer />
			<LogicCheck
				label={t(`formDesigner.labels.allData`)}
				hint={t(`formDesigner.elements.businessLogic.allData`)}
				nextProp={"allData"}
			/>
			<TwinInput
				nextProp={"dataMap"}
				reformatValues={reformatDataMapValues}
				values={value.dataMap}
				hint={t(`formDesigner.elements.businessLogic.dataMap`)}
			/>
		</div>
	);
};
